<template>

  <data-table
    :title="(name ? name : 'Tower Supplier') + (status ?  ': ' +status : '') "
    title-heading="h5"

    :url="supplierId ? urlSupplier :  urlGroup"
    :fields="fields"
    ref="towerSupplierSites"
    table-ref="towerSupplierSitesDataTable">

    <template #show="scope">
      <el-button type="text" icon="fa fa-angle-double-down" @click="showSite(scope.rowData.site_id)">&nbsp;Show</el-button>
    </template>

  </data-table>

</template>


<script>

import DateMixins from '@/mixins/DateMixins'

export default {

  mixins: [DateMixins],

  props: {
    name: {
      type: String,
      default: null
    },

    siteGroup: {
      type: String,
      default: null
    },

    supplierId: {
      type: Number,
      default: null
    },

    status: {
      type: String,
      default: null
    }
  },


  methods: {

    showSite (id) {
      alert('site id: ' + id)
    }

  },



  data () {
    return {

      urlSupplier: 'report/tower-supplier/sites/' + this.supplierId + (this.status ? '/' + this.status : ''),
      urlGroup: 'report/site-groups/sites/' + this.siteGroup + (this.status ? '/' + this.status : ''),
      rowData: null,

      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'site_id'
        },
        {
          title: 'Status',
          name: 'status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: !this.status || this.siteGroup
        },
        {
          title: 'Site Group',
          name: 'siteGroup',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          title: 'Site ID',
          name: 'siteId',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          title: 'Site Name',
          name: 'siteName'
        },
        {
          title: 'Handover',
          name: 'handover',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          title: 'Structure',
          name: 'structure',
          visible: this.supplierId
        },
        {
          title: 'Height',
          name: 'height',
          visible: this.supplierId
        }
/*        ,
        {
          name: '__slot:show'
        }
*/
      ]
    }
  }
}
</script>
